import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './product-select-blueparrott.component.html';
var ProductSelectBlueparrottComponent = (function () {
    function ProductSelectBlueparrottComponent() {
        this.toggleDropdown = false;
    }
    ProductSelectBlueparrottComponent.prototype.getOptionStyle = function (images) {
        if (images === void 0) { images = []; }
        var filteredImages = images.filter(function (image) { return /\.(jpg|jpeg|png)+/.test(image.url); });
        if (filteredImages.length === 0) {
            return '';
        }
        return "background-image: url('" + filteredImages[0].url + "?w=100&h=100&auto=format')";
    };
    ProductSelectBlueparrottComponent.prototype.selectProduct = function (index) {
        this.selectedProduct = this.products[index];
        this.toggleDropdown = false;
    };
    ProductSelectBlueparrottComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], ProductSelectBlueparrottComponent.prototype, "products", void 0);
    __decorate([
        Input('='),
        __metadata("design:type", Object)
    ], ProductSelectBlueparrottComponent.prototype, "selectedProduct", void 0);
    ProductSelectBlueparrottComponent = __decorate([
        Component({
            selector: 'productSelectBlueparrott',
            template: template,
        })
    ], ProductSelectBlueparrottComponent);
    return ProductSelectBlueparrottComponent;
}());
export { ProductSelectBlueparrottComponent };
